import { render, staticRenderFns } from "./contabilidadFormForm.vue?vue&type=template&id=bef94836"
import script from "./contabilidadFormForm.vue?vue&type=script&lang=js"
export * from "./contabilidadFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports